import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row, Spinner } from "react-bootstrap";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import PrivateApi from "../../services/PrivateApiService";
import { useAuthState } from "../../context/AuthContext";
import { useQuery, useQueryClient } from "react-query";
import SplashPage from "../SplashPage";

const NotificationDetailsPage = () => {

    const { user } = useAuthState();
    const { notification_id, secret } = useParams();
    const API = new PrivateApi();
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const [isRead, setIsRead] = useState();
    const [markReadLoading, setMarkReadLoading] = useState(false);


    const {data, error, isLoading} = useQuery(
        ["GET_SINGLE_NOTIFICATION_QUERY", notification_id], 
        () => API.get_Notifications_detail(notification_id), 
        { staleTime: Infinity }
    );


    useEffect(() => {
        if (data && data.data) {
            setIsRead(data.data.is_read)
        }
    }, [data])


    const markAsRead = () => {
        setMarkReadLoading(true);
        API.setRead_Notifications({id: data.data.id})
            .then(() => {
                queryClient.invalidateQueries("GET_USER_NOTIFICATION_QUERY");
                setIsRead(true);
                setMarkReadLoading(false);
                queryClient.invalidateQueries(["GET_USER_NOTIFICATION_QUERY"]);
                if (user.x_is_house_management)
                    navigate('/hw/dashboard/benachrichtigung/');
                else
                    navigate('/dashboard/news/');
            })
    }

    const downloadFile = () => {
        const linkSource = data.data.notification.file;
        const downloadLink = document.createElement('a');
        downloadLink.href = linkSource;
        downloadLink.download = data.data.notification.file_name;
        downloadLink.click();
    }

    if (error) return <SplashPage error={error} />
    if (isLoading) return <SplashPage />

    return (
        <Container className="text-start">
                {data? 
                    <>
                        <Row className="align-items-center">
                            <Col xl="10">
                                <h3>{user.x_is_house_management? "Benachrichtigungen":"News"}</h3>
                            </Col>
                            <Col xl="2" className="text-end">
                                {isRead?
                                    <Button className="btn-energo rounded-pill" onClick={() => navigate(user.x_is_house_management? "/hw/dashboard/benachrichtigung/": "/dashboard/news/")}>
                                        Zurück
                                    </Button>
                                    :
                                    markReadLoading?
                                        <Spinner animation="border" className="text-energo" />
                                        :
                                        <Button hidden={user.x_is_house_management && (secret === undefined || Number(secret) % 3 !== 0)} onClick={() => markAsRead()} className="btn-energo btn-md rounded-pill">Gelesen</Button>
                                }
                            </Col>
                        </Row>
                        <Row className="justify-content-center mt-5">
                            <Col xs="12" md="11" xl="12">
                                <Card className="shadow-lg" style={{ borderRadius: "15px", borderLeft: "3px solid #a2c13f", borderBottom: "3px solid #a2c13f" }}>
                                    <Card.Body>
                                        <Row>
                                            <Col xl="8">
                                                <h4>{data.data.notification.title}</h4>
                                                <p className="text-muted">{new Date(data.data.notification.created).toLocaleDateString('DE-de')}</p>
                                            </Col>
                                            <Col xl="4" className="text-end" hidden={data.data.notification.file === null}>
                                                <Button onClick={() => downloadFile()} className="btn-energo rounded-pill">
                                                    <FaCloudDownloadAlt size={25} /> &nbsp;
                                                    Dokument
                                                </Button>
                                            </Col>
                                        </Row>
                                        <Row className="mt-4">
                                            <Col xl="12">
                                                <div dangerouslySetInnerHTML={{__html: data.data.notification.message}}></div>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                        <Row className="mt-5">
                            <Col className="text-center">
                            </Col>
                        </Row>
                    </>
                :null}
        </Container>
    )
}
export default NotificationDetailsPage;